import React from 'react';
import { GraduationCap, Award } from 'lucide-react';
import { getImageUrl } from '../../utils/imageUtils.js';
import { Link } from 'react-router-dom';

const labels = {
  ne: {
    title: 'विशेषज्ञहरू',
    subtitle: 'यस क्षेत्रका विशेषज्ञहरूको प्रोफाइल।',
  },
  en: {
    title: 'Experts',
    subtitle: 'Profiles of experts in this sector.',
  },
};

const SectorExperts = ({ experts, language = 'ne' }) => {
  if (!experts || experts.length === 0) {
    return null;
  }

  const t = labels[language] || labels.ne;

  return (
    <section className="sector-experts">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{t.title}</h2>
          <p className="section-subtitle">{t.subtitle}</p>
        </div>

        <div className="experts__grid">
          {experts.map((expert, index) => (
            <Link to={`/experts/${expert._id}`} key={expert._id || index} className="expert-card">
              <div className="expert-card__avatar">
                {expert.photoUrl ? (
                  <img src={getImageUrl(expert.photoUrl)} alt={expert.name} />
                ) : (
                  <span className="expert-card__avatar-fallback">
                    {expert.name ? expert.name.charAt(0).toUpperCase() : '?'}
                  </span>
                )}
              </div>
              <h3 className="expert-card__name">{expert.name}</h3>
              {expert.education && (
                <div className="expert-card__meta">
                  <GraduationCap size={14} />
                  <span>{expert.education}</span>
                </div>
              )}
              {expert.yearOfExcellence && (
                <div className="expert-card__meta">
                  <Award size={14} />
                  <span>{expert.yearOfExcellence}</span>
                </div>
              )}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SectorExperts;